import React, { useEffect, useState } from "react";
import {
  Modal,
  Input,
  Select,
  Button,
  Checkbox,
  Avatar,
  Space,
  Typography,
} from "antd";
import FloatLabel from "../FloatLabel";
import { SearchOutlined } from '@ant-design/icons';
import "./CollaborationCoParentModal.css";

const { Option } = Select;
const { Title, Text } = Typography;

const PERMISSION_OPTIONS = [
  { id: 3, name: "Can Edit" }, 
  { id: 4, name: "Can View" },
];

const CollaborationModal = ({
  visible,
  onCancel,
  onSave,
  collaborators,
  initialSelected,
   selectedCoupleId,
 couples,
}) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [allUsers, setAllUsers] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [selected, setSelected] = useState([]);
  const [inviteEmail, setInviteEmail] = useState("");
  const [invitePermission, setInvitePermission] = useState(PERMISSION_OPTIONS[1]); // Default to "Can View"
    const parentCouple = couples.find((couple) => couple.id === selectedCoupleId);
  // console.log("parentCouple>>>", parentCouple);
  const parentUsers = [
  {
    id: parentCouple?.parent1.user_id,
    name: parentCouple?.parent1.nickname || parentCouple?.parent1.name,
    email: parentCouple?.parent1.email,
    avatar: "", // Add avatar URL if available
  },
  {
    id: parentCouple?.parent2.user_id,
    name: parentCouple?.parent2.nickname || parentCouple?.parent2.name,
    email: parentCouple?.parent2.email,
    avatar: "", // Add avatar URL if available
  },
];

  useEffect(() => {
    if (!visible) return;

    const enriched = collaborators.map((user) => {
      const matched = initialSelected.find((sel) => sel.id === user.id);
      return {
        ...user,
        permission: matched?.permission || PERMISSION_OPTIONS[1], // Default permission to "Can View"
      };
    });

    // Merge new collaborators with existing invites (preserve invites)
    setAllUsers((prev) => {
      const merged = [...enriched];
      prev.forEach((user) => {
        if (!merged.find((u) => u.id === user.id)) {
          merged.push(user);
        }
      });
      return merged;
    });

    setSelected(
      enriched.filter((u) => initialSelected.find((s) => s.id === u.id))
    );
    setSearchTerm("");
    setInviteEmail("");
    setInvitePermission(PERMISSION_OPTIONS[1]); // Reset invite permission to "Can View"
  }, [visible]);

  useEffect(() => {
    setFiltered(
      allUsers.filter(
        (user) =>
          user.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
          user.email.toLowerCase().includes(searchTerm.toLowerCase())
      )
    );
  }, [searchTerm, allUsers]);

  const handleSearch = (e) => setSearchTerm(e.target.value);

  const toggleSelection = (user) => {
    const exists = selected.find((u) => u.id === user.id);
    if (exists) {
      setSelected(selected.filter((u) => u.id !== user.id));
    } else {
      setSelected([...selected, user]);
    }
  };

  const updatePermission = (userId, permissionId) => {
    const newPermission = PERMISSION_OPTIONS.find((p) => p.id === permissionId);
    setAllUsers((prev) =>
      prev.map((u) => (u.id === userId ? { ...u, permission: newPermission } : u))
    );
    setSelected((prev) =>
      prev.map((u) => (u.id === userId ? { ...u, permission: newPermission } : u))
    );
  };

  const handleInvite = () => {
    if (!inviteEmail.trim()) return;

    const newUser = {
      id: `invite-${Date.now()}`,
      name: inviteEmail.split("@")[0],
      email: inviteEmail,
      avatar: `https://i.pravatar.cc/40?u=${inviteEmail}`,
      permission: invitePermission,
    };

    setAllUsers((prev) => [...prev, newUser]);
    setSelected((prev) => [...prev, newUser]);
    setInviteEmail("");
    setInvitePermission(PERMISSION_OPTIONS[1]); // Reset invite permission to "Can View"
  };

  return (
    <Modal
      title={<Title level={4}>Collaboration</Title>}
      open={visible}
      onCancel={onCancel}
      footer={null}
      width={600}
    >
  <div style={{marginBottom: 15}}>
  <FloatLabel
            label="Search"
            name="search"
            value={inviteEmail}
          >
            {/* <SearchOutlined /> */}
            <Input
              value={searchTerm}
              className="custom-search-input has-prefix"
              prefix={<SearchOutlined />}
              placeholder=""
              onChange={handleSearch}
             
            />
          </FloatLabel>
          </div>
      {parentUsers.map((user) => (
        <div
          key={user.id}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: 30,
          }}
        >
          <Space>
            <Select
              value={user.permission?.id}
              onChange={(val) => updatePermission(user.id, val)}
              style={{ width: 120 }}
            >
            </Select>
            <Avatar src={user.avatar} />
            <Text>{user.email}</Text>
          </Space>
          <Checkbox
            checked={!!selected.find((u) => u.id === user.id)}
            onChange={() => toggleSelection(user)}
          />
        </div>
      ))}

      {/* <div style={{ marginTop: 24 }}>
        <Text strong>Invite Members</Text>
        <div
          className="inaviteEmailSection"
          style={{ display: "flex", gap: 8, marginTop: 8 }}
        >
          <FloatLabel
            label="Email"
            name="inviteNewEmail"
            value={inviteEmail}
          >
            <Input
              value={inviteEmail}
              placeholder=""
              onChange={(e) => setInviteEmail(e.target.value)}
            />
          </FloatLabel>
          {/* <Select
            value={invitePermission.id}
            onChange={(val) =>
              setInvitePermission(
                PERMISSION_OPTIONS.find((p) => p.id === val) || PERMISSION_OPTIONS[1]
              )
            }
            className="invitePermissionSelect"
            style={{ width: 120 }}
          >
            {PERMISSION_OPTIONS.map((option) => (
              <Option key={option.id} value={option.id}>
                {option.name}
              </Option>
            ))}
          </Select> */}
          {/* <Button
            type="primary"
            onClick={handleInvite}
            className="invite-control"
          >
            Invite
          </Button>
        </div>
      </div> */}

      <div style={{ textAlign: "right", marginTop: 32 }}>
        <Button
          type="primary"
          className="setup-btn"
          block
          style={{
            backgroundColor: "#a855f7",
            borderColor: "#a855f7",
            color: "#fff",
          }}
          onClick={() => onSave(selected)}
          disabled={selected.length === 0}
        >
          Save
        </Button>
      </div>
    </Modal>
  );
};

export default CollaborationModal;
